<template>
    <div class="financial-options">
        <h2>
            Cost shouldn't be a barrier to your mental wellness.
        </h2>
        <div class="options">
            <div class="option">
                <img src="@/assets/hand-icon.png" alt="Card" class="card-icon">
                <div class="option__header">
                    Financial assistance available for qualifying patients
                </div>
                <div v-if="this.$store.getters.isPrepayment" class="option__info">
                    Learn about programs that may reduce your cost.
                </div>
                <div v-else class="option__info option__info--large">
                    Though you owe nothing now, learn about programs that may reduce your out-of-pocket cost.
                </div>
            </div>
            <div class="vertical-rule" />
            <div class="option">
                <img src="@/assets/zero-percent-icon.png" alt="Card" class="card-icon">
                <div class="option__header">
                    Interest-free payment plans available
                </div>
                <div class="option__info">
                    Flexible payment options are available.
                </div>
            </div>
        </div>
        <div class="sub-header">
            Our team is here to help you find an option that works for you.
        </div>
        <div class="contact-row">
            <a :href="`tel:${$config.customerSupportPhoneDial}`">{{ $config.customerSupportPhoneDisplay }}</a>
            <a href="mailto:support@genesight.com">support@genesight.com</a>
        </div>
        <p>
            GeneSight support is available Monday through Friday, 8:00am to 8:00pm EST.
        </p>
    </div>
</template>

<script>
export default {
    name: "ReviewFinancialOptions"
};
</script>

<style lang="scss" scoped>
.financial-options {
    border-radius: 8px;
    background: var(--Color-blue-bright-25, #F6FBFF);
    padding: 32px 24px;

    h2 {
        color: #000;
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-hm, 24px);
        font-style: normal;
        font-weight: 500;
        line-height: 133%; /* 31.92px */
        letter-spacing: -0.48px;
    }

    .options {
        display: flex;
        align-items: flex-start;
        justify-content: space-around;
        margin: 40px 0;

        .vertical-rule {
            background: var(--Color-blue-bright-200, #8CC7F7);
            width: 1px;
            height: 170px;
        }

        .option {
            width: calc(50% - 1px);

            img {
                width: 68px;
                margin-bottom: 8px;
            }

            .option__header {
                color: #0092E1;
                font-family: var(--font-family-Inter, Inter);
                font-size: var(--font-size-tl, 18px);
                font-style: normal;
                font-weight: 600;
                line-height: 156%; /* 28.08px */
                letter-spacing: -0.18px;
                margin-bottom: 8px;
            }

            .option__info {
                color: var(--gray-800, var(--Color-gray-800, #202939));
                font-family: var(--font-family-Inter, Inter);
                font-size: var(--font-size-tl, 18px);
                font-style: normal;
                font-weight: 400;
                line-height: 156%; /* 28.08px */
                letter-spacing: -0.18px;

                &.option__info--large {
                    max-width: 460px;
                    margin-left: auto;
                    margin-right: auto;
                }
            }
        }
    }

    .sub-header {
        color: #000;
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-hs, 20px);
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 30px */
        letter-spacing: -0.2px;
        margin-bottom: 8px;
    }

    .contact-row {
        color: var(--Color-blue-bright-500, #0691EF);
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-hs, 20px);
        font-style: normal;
        font-weight: 600;
        line-height: 150%; /* 30px */
        letter-spacing: -0.2px;
        margin-bottom: 8px;

        a {
            text-decoration: none;
            margin: 0 28px;
        }
    }

    p {
        color: var(--gray-800, var(--Color-gray-800, #202939));
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-tl, 18px);
        font-style: normal;
        font-weight: 400;
        line-height: 156%; /* 28.08px */
        letter-spacing: -0.18px;
    }
}

@include small-desktop() {
    .financial-options {

        .options {
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .option {
                width: 100%;
            }

            .vertical-rule {
                width: 90%;
                height: 1px;
                margin: 24px 0;
                max-width: 500px;
            
            }
        }
    }
}

@include sm() {
    .financial-options {
        padding: 32px 10px;

        h2 {
            font-size: 18px;
        }

        .options {
            margin: 16px 0;

            .option {

                img {
                    width: 55px;
                }

                .option__header {
                    font-size: 16px;
                }

                .option__info {
                    font-size: 16px;
                }
            }
        }

        .sub-header {
            font-size: 16px;
        }

        .contact-row a {
            width: 100%;
            display: block;
            margin: 0;
            font-size: 16px;
        }

        p {
            font-size: 16px;
        }
    }
}
</style>
